import { createTenantClient } from "@qr-menu/api-tenant";
import { clearTenantToken, readTenantToken } from "./session";

// Unset/blank keeps baseUrl "" so requests stay relative and the local Vite
// proxy (or same-origin production hosting) still resolves them.
function resolveApiBaseUrl(): string {
  const raw = import.meta.env.VITE_API_BASE_URL;
  if (typeof raw !== "string") return "";
  const trimmed = raw.trim();
  return trimmed === "" ? "" : trimmed.replace(/\/+$/, "");
}

export const tenantApi = createTenantClient({
  baseUrl: resolveApiBaseUrl(),
  getToken: readTenantToken,
  onUnauthorized: () => {
    clearTenantToken();
    if (typeof window !== "undefined") {
      window.location.assign("/login");
    }
  },
});
